import { queryStringParse } from './utils';

const firstUpper = s => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase();

export function getRequestInfo(params) {
  const result = {};

  // 在请求里提取一些信息
  const host = params.url || '';
  const reqHeaders = params.headers;

  let match;
  let pathAndSearch;
  if (host) {
    if (host.includes('service.cos.myqcloud.com')) {
      return {
        method: params.method,
        action: 'GetService',
      };
    }
    match = host.match(/^https?:\/\/(.*)\.(cos|ci|pic)\.([^.]+)\.myqcloud\.com\/(.*)$/);
    [, result.bucket, result.hostType, result.region, pathAndSearch] = match;
  }

  result.method = params.method;
  result.key = pathAndSearch.replace(/[?#].*$/, '');
  const query = queryStringParse(pathAndSearch.replace(/^[^?]*\??/, ''));
  const { method, key } = result;
  // 判断当前是什么操作
  let action = '';
  if (method === 'HEAD') {
    action = `Head${key ? 'Bucket' : 'Object'}`;
  } else if ('location' in query) {
    action = `${firstUpper(method)}BucketLocation`;
  } else if ('policy' in query) {
    action = `${firstUpper(method)}BucketPolicy`;
  } else if ('policy' in query) {
    action = `${firstUpper(method)}BucketLifecycle`;
  } else if ('cors' in query) {
    action = `${firstUpper(method)}BucketCORS`;
  } else if ('versioning' in query) {
    action = `${firstUpper(method)}BucketVersioning`;
  } else if ('image-slim' in query) {
    action = `${firstUpper(method)}BucketSlim`;
  } else if ('replication' in query) {
    action = `${firstUpper(method)}BucketReplication`;
  } else if ('website' in query) {
    action = `${firstUpper(method)}BucketWebsite`;
  } else if ('domain' in query) {
    action = `${firstUpper(method)}BucketDomain`;
  } else if ('logging' in query) {
    action = `${firstUpper(method)}BucketLogging`;
  } else if ('accelerate' in query) {
    action = `${firstUpper(method)}BucketAccelerate`;
  } else if ('encryption' in query) {
    action = `${firstUpper(method)}BucketEncryption`;
  } else if ('inventory' in query && 'id' in query) {
    action = `${firstUpper(method)}BucketInventory`;
  } else if ('inventory' in query) {
    action = 'List Bucket Inventory Configurations';
  } else if ('tagging' in query) {
    action = `${firstUpper(method) + (key ? 'Object' : 'Bucket')}Tagging`;
  } else if ('acl' in query) {
    action = `${firstUpper(method) + (key ? 'Object' : 'Bucket')}ACL`;
  } else if ('select' in query && method === 'POST') {
    action = 'SelectObjectContent';
  } else if ('versions' in query && method === 'GET') {
    action = 'GetBucketObjectVersions';
  } else if ('restore' in query && method === 'POST') {
    action = 'RestoreObject';
  } else if ('delete' in query && method === 'POST') {
    action = 'DeleteMultipleObjects';
  } else if ('uploads' in query && method === 'GET') {
    action = 'ListMultipartUploads';
  } else if ('uploads' in query && method === 'POST') {
    action = 'InitiateMultipartUpload';
  } else if (query.uploadId && method === 'GET') {
    action = 'ListParts';
  } else if (query.uploadId && query.partNumber && method === 'PUT') {
    action = 'UploadPart';
  } else if (query.uploadId && method === 'POST') {
    action = 'CompleteMultipartUpload';
  } else if (query.uploadId && method === 'DELETE') {
    action = 'CompleteMultipartUpload';
  } else if (query.uploadId && method === 'DELETE') {
    action = 'CompleteMultipartUpload';
  } else if (query.uploadId && method === 'PUT' && reqHeaders['x-cos-copy-source']) {
    action = 'UploadPartCopy';
  } else if (method === 'PUT' && reqHeaders['x-cos-copy-source']) action = 'PutObjectCopy';
  else action = firstUpper(method) + (key ? 'Object' : 'Bucket');
  result.action = action;

  // 返回结果
  return result;
}

// 以下代码在新增一个 export 后可删除
export const a = 1;
